export const prefixTranslation =
  'administration.externalCourses.list.table.actions'
